ikart.webshop.product_ui.ProductList = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);
		ikart.webshop.product_ui.prepare_product_renderer(this, "List View");
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 200 ? title.substr(0, 200) + "..." : title;

			html += `<div class="row list-row w-100 mb-4">`;
			html += me.get_image_html(item, title, me.settings);
			html += me.get_row_body_html(item, title, me.settings);
			html += `</div>`;
		});

		const product_wrapper = this.products_section[0];
		if (product_wrapper) {
			if (this.append) {
				product_wrapper.insertAdjacentHTML("beforeend", html);
			} else {
				product_wrapper.innerHTML = html;
			}
		}
	}

	get_image_html(item, title, settings) {
		let image = item.website_image || item.thumbnail;
		let wishlist_enabled = !item.has_variants && settings.enable_wishlist;
		let image_html = ``;

		if (image) {
			image_html += `
				<div class="col-12 col-lg-6 border text-center rounded list-image">
					<button type="button" class="product-image-preview-trigger product-list-link"
						data-image-src="${ ikart.webshop.product_ui.attr(image) }"
						data-image-alt="${ ikart.webshop.product_ui.attr(title) }">
						<img itemprop="image" class="website-image h-100 w-100"
							alt="${ ikart.webshop.product_ui.attr(title) }"
							src="${ ikart.webshop.product_ui.attr(image) }"
							loading="lazy" decoding="async">
					</button>
					${ wishlist_enabled ? this.get_wishlist_icon(item): '' }
				</div>
			`;
		} else {
			image_html += `
				<div class="col-12 col-lg-6 border text-center rounded list-image">
					<div class="card-img-top no-image-list">
						${ frappe.get_abbr(title) }
					</div>
					${ wishlist_enabled ? this.get_wishlist_icon(item): '' }
				</div>
			`;
		}

		return image_html;
	}

	get_row_body_html(item, title, settings) {
		let body_html = `<div class="col-12 col-lg-6 text-left list-row-body">`;
		body_html += this.get_title_html(item, title, settings);
		body_html += this.get_group_variant_buttons(item);
		body_html += this.get_item_details(item, settings);
		body_html += `</div>`;
		return body_html;
	}

	get_title_html(item, title, settings) {
		let title_html = `<div class="product-list-title-row">`;
		title_html += `
			<div class="col-8 product-list-title-wrap">
				<a class="product-link" href="/${ item.route || '#' }"
					aria-label="${ ikart.webshop.product_ui.attr(title) }">
					${ title }
				</a>
			</div>
		`;

		if (settings.enabled) {
			title_html += `<div class="col-4 product-list-action-wrap cart-action-container list-cart-action ${item.in_cart ? 'd-flex' : ''}">`;
			title_html += this.get_primary_button(item, settings);
			title_html += `</div>`;
		}
		title_html += `</div>`;

		return title_html;
	}

	get_group_variant_buttons(item) {
		if (!item.group_variants || !item.group_variants.length) {
			return ``;
		}

		const buttons = item.group_variants.map(variant => `
			<button type="button"
				class="btn btn-xs btn-default product-size-option ${ variant.is_active ? 'active' : '' }"
				aria-pressed="${ variant.is_active ? 'true' : 'false' }"
				${ ikart.webshop.product_ui.get_group_variant_attrs(variant) }>
				${ variant.label }
			</button>
		`).join("");

		return `
			<div class="product-size-options product-size-options-list mb-2" aria-label="${ __("Available sizes") }">
				${ buttons }
			</div>
		`;
	}

	get_brand_label(item) {
		const attr = ikart.webshop.product_ui.attr;
		const brand = String(item.brand || "").trim();
		// show the brand (clickable) or nothing — never the category/item group
		if (!brand) {
			return "";
		}
		const href = ikart.webshop.product_ui.get_brand_filter_url(brand);
		return `<a class="product-brand-link" href="${ attr(href) }" itemprop="brand">${ attr(brand) }</a> | `;
	}

	get_item_details(item, settings) {
		let details = `
			<p class="product-code">
				${ this.get_brand_label(item) }${ __('Item Code') } : <span class="product-item-code-value">${ item.item_code || '' }</span>
			</p>
			<div class="product-description mt-2">
				${ item.short_description || '' }
			</div>
			<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer"
				data-display-rate="${ ikart.webshop.product_ui.attr(item.display_rate || '') }"
				data-currency="${ ikart.webshop.product_ui.attr(item.currency || '') }"
				data-formatted-price="${ ikart.webshop.product_ui.attr(item.formatted_price || '') }"
				data-gst-inclusive-price="${ ikart.webshop.product_ui.attr(item.gst_inclusive_price || '') }"
				data-formatted-gst-inclusive-price="${ ikart.webshop.product_ui.attr(item.formatted_gst_inclusive_price || '') }"
				data-formatted-gst-rate="${ ikart.webshop.product_ui.attr(item.formatted_gst_rate || '') }"
				data-gst-label="${ ikart.webshop.product_ui.attr(item.gst_label || __('GST')) }"
				data-stock-uom="${ ikart.webshop.product_ui.attr(item.stock_uom || item.uom || '') }"
				data-order-uom="${ ikart.webshop.product_ui.attr(item.order_uom || item.stock_uom || item.uom || '') }"
				data-conversion-factor="${ ikart.webshop.product_ui.attr(item.conversion_factor || 1) }"
				data-use-alternate-order-uom="${ item.use_alternate_order_uom ? 1 : 0 }">
				<span class="product-unit-price">${ item.formatted_price || __("Price on request") }</span>
				<small class="formatted-price product-stock-uom ml-1">${ item.formatted_price && (item.stock_uom || item.uom) ? `/ ${ item.stock_uom || item.uom }` : "" }</small>
		`;

		if (item.formatted_mrp) {
			details += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}

		details += `
			<div class="small text-muted mt-1 product-gst-inclusive-row ${ item.formatted_gst_inclusive_price ? '' : 'hidden' }">
				${ __("Incl. GST") }
				<span class="product-gst-rate-value">${ item.formatted_gst_rate ? `(${ item.formatted_gst_rate })` : "" }</span>
				:
				<strong class="product-gst-inclusive-value">${ item.formatted_gst_inclusive_price || '' }</strong>
			</div>
		`;

		details += this.get_stock_availability(item, settings);
		details += `<div class="small product-selected-total mt-1 hidden"></div>`;
		details += `</div>`;

		return details;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<br>
					<span class="out-of-stock mt-2" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<br>
					<span class="out-of-stock mt-2">${ __("Out of stock") }</span>
				`;
			} else if (item.is_stock) {
				return `
					<br>
					<span class="in-stock in-green has-stock mt-2"
						style="font-size: 14px;">${ __("In stock") }</span>
				`;
			}
		}
		return ``;
	}

	get_wishlist_icon(item) {
		const attr = ikart.webshop.product_ui.attr;
		let icon_class = item.wished ? "wished" : "not-wished";

		return `
			<button type="button" class="like-action-list ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ attr(item.item_code) }"
				aria-label="${ __("Toggle wishlist") }"
				aria-pressed="${ item.wished ? 'true' : 'false' }">
				<svg class="icon sm" aria-hidden="true">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</button>
		`;
	}

	get_quantity_selector(item) {
		// Shared marketplace-style stepper (see grid.js) — identical control on
		// every catalogue; cart flow unchanged (keeps .product-qty-input).
		return ikart.webshop.product_ui.get_marketplace_qty_selector(item, "mb-2");
	}

	get_primary_button(item, settings) {
		const attr = ikart.webshop.product_ui.attr;
		const has_price = Boolean(item.formatted_price);
		if (item.has_variants) {
			return `
				<a href="/${ item.route || '#' }">
					<div class="btn btn-sm btn-explore-variants btn mb-0 mt-0">
						${ __("Explore") }
					</div>
				</a>
			`;
		} else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
			return `
				<div class="list-cart-button-wrapper">
					<div class="product-purchase-row">
						<button type="button" id="${ item.name }" class="btn
							btn-sm btn-primary btn-add-to-cart-list product-purchase-button mb-0
							${ item.in_cart ? 'hidden' : '' }"
							data-item-code="${ attr(item.item_code) }"
							aria-label="${ settings.enable_checkout ? __("Add to Cart") :  __("Add to Quote") }">
							<span class="cart-action-icon">
								<svg class="icon icon-md" aria-hidden="true">
									<use href="#icon-shopping-cart"></use>
								</svg>
							</span>
						</button>

						<span class="text-muted small product-price-on-request ${ has_price ? 'hidden' : '' }">
							${ __("Price on request") }
						</span>
					</div>

					<div class="cart-indicator list-indicator ${item.in_cart ? '' : 'hidden'}"
						data-item-code="${ attr(item.item_code) }">
						${ ikart.webshop.product_ui.get_cart_indicator_text(
							item.cart_qty || 1,
							item.order_uom,
							item.use_alternate_order_uom
						) }
					</div>

					<a href="/cart?highlight_item=${ encodeURIComponent(item.item_code || "") }">
						<div id="${ item.name }" class="btn
							btn-sm btn-primary btn-add-to-cart-list
							ml-4 go-to-cart mb-0 mt-0
							${ item.in_cart ? '' : 'hidden' }"
							data-item-code="${ attr(item.item_code) }">
							${ settings.enable_checkout ? __("Go to Cart") :  __("Go to Quote") }
						</div>
					</a>
				</div>
			`;
		} else {
			return ``;
		}
	}

};
